import React from "react";
import bgImage from "../components/images/faq-bg.png"; // replace with your actual background image

export default function OurBeers() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Full-page dark overlay */}
      <div className="absolute inset-0 bg-black/80 z-0"></div>

      {/* FAQ content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 py-20 mt-6 md:mt-12">
        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-12 text-center text-white">
          Frequently Asked Questions
        </h2>

        <div className="space-y-10 text-left">
          {/* FAQ 1 */}
          <div>
            <h3 className="text-lg font-semibold text-amber-400 mb-3">
              1. What does Liquora Global do?
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              Liquora Global is India’s <strong>exclusive importer and sole distributor</strong> of premium international alcoholic beverages, including <strong>Wild Boar</strong>, <strong>Little Fat Lamb</strong>, and other select global brands. We specialize in bringing high-quality, unique products from around the world to the Indian market, ensuring that consumers and businesses have access to exceptional international beverages that meet global standards.
            </p>
          </div>

          {/* FAQ 2 */}
          <div>
            <h3 className="text-lg font-semibold text-amber-400 mb-3">
              2. Where are the products imported from?
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              Our portfolio features carefully curated brands sourced from <strong>Australia, Europe</strong>, and other renowned brewing and distilling regions. Each product we represent undergoes strict quality checks and complies with Indian import regulations, ensuring authenticity, consistency, and excellence in every bottle or can.
            </p>
          </div>

          {/* FAQ 3 */}
          <div>
            <h3 className="text-lg font-semibold text-amber-400 mb-3">
              3. Are Liquora Global products available for individual purchase?
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              Liquora Global primarily operates as a <strong>B2B distributor</strong>, partnering with retail chains, licensed outlets, bars, and hospitality groups. However, consumers can find our brands such as Wild Boar and Little Fat Lamb at leading liquor stores, bars, and e-commerce platforms (subject to state laws and availability).
            </p>
          </div>

          {/* FAQ 4 */}
          <div>
            <h3 className="text-lg font-semibold text-amber-400 mb-3">
              4. How does Liquora Global ensure product quality and authenticity?
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              We work directly with our partner breweries and distilleries to import products in controlled conditions, maintaining their original taste and integrity. Every shipment adheres to <strong>FSSAI</strong> and excise regulations, with rigorous checks at every stage — from origin to final distribution — to ensure only genuine, high-quality beverages reach the market.
            </p>
          </div>

          {/* FAQ 5 */}
          <div>
            <h3 className="text-lg font-semibold text-amber-400 mb-3">
              5. How can I become a distributor or retail partner for Liquora Global brands?
            </h3>
            <p className="text-white/90 text-lg leading-relaxed">
              We’re always looking to expand our network of distributors and retail partners across India. Interested parties can contact our business development team through our website’s <strong>Contact page</strong> or by emailing our sales department. Once we receive your details, our team will guide you through the onboarding process, licensing requirements, and partnership opportunities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
